import React from 'react'
import style from './articles.style'

const AmoCrmGa = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение amoCRM</h2>
      <h3>Шаг 1. Настройка авторизации CRM</h3>
      <ol>
        <li>
          В поле <strong>Subdomain</strong> введите URL-адрес вашего проекта в
          amoCRM. Обычно он выглядит так:{' '}
          <strong>{`https://<subdomain> .amocrm.ru`}</strong>
        </li>
        <li>
          В поле <strong>Email</strong> введите адрес электронной почты для
          авторизации в amoCRM.
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image3amo.jpg" alt="true" />
        </figure>
        <li>
          В поле <strong>API-ключ</strong> введите API-ключ amoCRM. Для этого
          зайдите в amoCRM и скопируйте его из профиля пользователя:
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/image1amo.jpg" alt="true" />
        </figure>
        <li>
          По умолчанию включена галочка -{' '}
          <strong>отправлять продажи с пустим Client ID</strong>. Это означает,
          что в продажи отправляются сделки с Client ID и без Client ID
          (например заведенные вручную). Если вы хотите отправлять в продажи
          сделки только с Client ID, то отключите галочку.
        </li>
        <li>
          Нажмите кнопку <strong>Далее</strong>.
        </li>
      </ol>
      <h3>ШАГ 2. Расширенная настройка</h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/image2amo.jpg" alt="true" />
      </figure>
      <ol>
        <li>
          Выберите поле CRM, в которое передается{' '}
          <strong>Google Client ID</strong>. Пример Client ID:
          “GA1.2.2029541258.1577186246" (GA1.2.XXXXXXXXXX.XXXXXXXXXX). Если вы
          не знаете, есть ли у вас в CRM поле <strong>“Client ID”</strong>,
          выберите “НЕ ВЫБРАНО”, позже вы сможете настроить это поле в личном
          кабинете ROMI center. Обратитесь в тех. поддержку ROMI center, чтобы
          вам помогли с параметром Client ID.
        </li>
        <li>
          Выберите, куда хотите отправлять данные. Мы рекомендуем отправлять
          данные в <strong>“Покупки в электронной торговле”</strong>. Отправка
          данных в <strong>Электронную торговлю</strong> позволяет передавать
          дополнительные данные: название товара/услуги, количество, цену,
          передавать данные о возвратах и другое.
          <p>
            Отправка данных в <strong>Цель “Успешные продажи”</strong>,
            позволяет передавать только количеству и сумму продаж.
          </p>
        </li>
        <li>
          Выберите поле <strong>Прибыль</strong> в вашей CRM. Поле{' '}
          <strong>Прибыль</strong>
          необходимо выбирать, если вам надо передавать не{' '}
          <strong>Сумму</strong> сделки, а <strong>Прибыль</strong> из
          отдельного поля. Прибыль рассчитывается по формуле:{' '}
          <strong>Сумма сделки – Расходы = Прибыль</strong>. Если у вас нет поля
          Прибыль, оставьте это поле пустым. Сумма сделки будет браться
          автоматически из стандартного поля CRM.
        </li>
        <li>
          Если у вас несколько воронок продаж, вы можете выбрать любую из
          необходимых вам воронок. В каждой воронке можно выбрать статус
          <strong>“успешно завершенной сделки”</strong>. Добавить новую воронку
          можно нажав ссылку <strong>“Добавить дополнительную воронку”</strong>,
          которая находится под полем “воронка”.
        </li>
        <li>
          Выберите статусы сделки, которые соответствуют{' '}
          <strong>“успешно завершенной сделке”</strong>. Можно выбрать несколько
          статусов, если вам необходимо например учитывать разные способы
          оплаты: “Оплата безналом” и “Оплата наличными”. Обратите внимание, что
          одна сделка не может проходить через два статуса оплаты. Пример:
          “Предоплата” и “Полная оплата”, в таком случае сделка задублируется в
          отчете продаж.
        </li>
        <li>
          Выберите статус <strong>“Возврата”</strong> в вашей CRM системе. Эта
          опция доступна, только в случае, если выбрана отправка в{' '}
          <strong>Электронную торговлю</strong>. Статус “Возврат” не является
          обязательным полем, вы можете выбрать значение “НЕ ВЫБРАНО”. Статус
          возврата нужно выбирать, если у вас предусмотрен возврат денежных
          средств клиенту за товар или услугу. Данные о возвратах также
          отправляются в отчет о продажах. Обратите внимание, что переводить
          сделку в статус возврат необходимо в случае, если ранее, она была
          завершена как “успешная”.
        </li>
        <li>
          Нажмите кнопку <strong>Завершить</strong>.
        </li>
      </ol>
      <p>
        Проверьте корректность введенных данных, на вновь загруженной странице.
      </p>
      <p>
        Нажмите кнопку <strong>Вернуться на дашборд</strong>.
      </p>
      <p>Готово!</p>
    </article>
  )
}

export default style(AmoCrmGa)
